import React, {Component} from "react";
import {Form, Input, Select} from "antd";
import {validateField} from "../../common/validation";
import './Member.css';

class CitySelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:"",
            error: this.props.validationInfo.citySelectionError,
            isClean:false,
        };
        console.log("this.state.error==>",this.state.error);
        this.validateClass=this.validateClass.bind(this);
        this.validateMessage=this.validateMessage.bind(this);
        this.validateField=this.validateField.bind(this);
        this.checkComponentValidation=this.checkComponentValidation.bind(this);
    }


    componentDidMount (){
        window.scrollTo(0, 0);
       // this.checkComponentValidation();
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.props.validationInfo.citySelectionError;//this.state.error//
        console.log("citySelectionError as state",error);
        error = Object.assign(error, {[id]: result});
        //this.setState({error});
        //
        console.log("citySelectionError after set",error);
        this.props.validateStep("citySelectionError",error);
        this.checkComponentValidation(error);
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    checkComponentValidation()
    {
        let error = this.props.validationInfo.citySelectionError;
        console.log("currenterror",error);
        let valid=false;
        console.log("this.props.memberInfo.sehir.id ",this.props.memberInfo.city.id );
        if ( ( error["tAd"] !== undefined) && ( error["tSoyad"] !== undefined ) && ( error["tTckNo"] !== undefined) && (this.props.memberInfo.city.id !== null ))
        {
            if (error["tAd"]["valid"] && error["tSoyad"]["valid"] && error["tTckNo"]["valid"]) {
                console.log("valid true");
                valid = true;
            }
        }
        this.props.validateStep("citySelectionValid",valid);
    }


    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        //var cities  = this.props.cities ;
        return (
            <div className="contactInfo-container">
                <Form {...formItemLayout}>

                    <Form.Item
                        label="Ad:">
                        <Input maxlength={25} value= {this.props.memberInfo.ad}  placeholder="Adınız" allowClear  onChange={(e)=>this.props.onInfoChange("ad",e.target.value)} />
                    </Form.Item>

                    <Form.Item
                        label="Soyad:">
                        <Input maxlength={25}  value={this.props.memberInfo.soyad} placeholder="Soyadınız" allowClear  onChange={(e)=>this.props.onInfoChange("soyad",e.target.value)} />
                    </Form.Item>

                    <Form.Item
                        label="TC Kimlik No:">
                        <Input maxlength={11}  value={this.props.memberInfo.tcKimlikNo} placeholder="TC Kimlik Numaranız" allowClear  onChange={(e)=>this.props.onInfoChange("tcKimlikNo",e.target.value)} />
                    </Form.Item>

                    <Form.Item
                        label="İl:">
                        <Select maxlength={11}  value={this.props.memberInfo.city.id}  placeholder="Seçiniz" allowClear  onChange={(e)=>this.props.onCityInfoChange("id",e)}>
                        {this.props.cities.map((city) => <option key={city.id} value={city.id}>{city.ad}</option>)}
                        </Select>
                </Form.Item>
                </Form>
            </div>
        );
    }
}

export default CitySelection;


// WEBPACK FOOTER //
// ./src/page/member/CitySelection.js